import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import passarinho from './imgs/passarinho.png';
import processoSeletivo from './imgs/processoSeletivoFisica.png';
import material from './imgs/mat.png';
import gabarito from './imgs/gab.png';
import questao from './imgs/qst.png';
import InstagramWidget from './utils/Instagram';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const content = [
    { image: material, title: 'Materiais de estudo', text: 'Conteúdos para dominar os temas mais recorrentes em olimpíadas e vestibulares.', link: '/matemática-materiais', action: 'Explorar materiais' },
    { image: gabarito, title: 'Gabaritos comentados', text: 'Entenda as resoluções e descubra caminhos mais eficientes para cada questão.', link: '/matemática-gabaritos', action: 'Ver gabaritos' },
    { image: questao, title: 'Problemas mensais', text: 'Desafios de diferentes níveis para exercitar o raciocínio e ir mais longe.', link: '/matemática-problemas', action: 'Resolver problemas' },
];

const Home = () => {
    const defaultBanners = [
        { id: 'default-olympic-birds', src: passarinho, alt: 'Olympic Birds' },
        { id: 'default-processo-seletivo', src: processoSeletivo, alt: 'Processo seletivo de física' },
    ];
    const [banners, setBanners] = useState(null);

    useEffect(() => {
        let isMounted = true;

        fetch('/api/banners')
            .then(response => response.ok ? response.json() : Promise.reject())
            .then(data => {
                if (!isMounted) return;
                const visibleDefaults = defaultBanners.filter(item => !data.hiddenDefaults?.includes(item.id));
                setBanners([
                    ...visibleDefaults,
                    ...(data.items || []).map(item => ({ id: item.id, src: item.url, alt: item.alt })),
                ]);
            })
            .catch(() => {
                if (isMounted) {
                    setBanners(defaultBanners);
                }
            });

        return () => {
            isMounted = false;
        };
    }, []);

    const hasMultipleBanners = banners?.length > 1;
    const settings = {
        dots: hasMultipleBanners,
        infinite: hasMultipleBanners,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: hasMultipleBanners,
        autoplaySpeed: 3000,
        arrows: false,
        pauseOnHover: true,
    };

    return (
        <main>
            <section className="hero" aria-label="Destaques Olympic Birds">
                {banners === null ? (
                    <div className="hero-loading" aria-busy="true">Carregando destaque...</div>
                ) : (
                    <Slider key={banners.map(banner => banner.id).join('-')} {...settings}>
                        {banners.map(banner => (
                            <div key={banner.id}>
                                <img className="passarinho" src={banner.src} alt={banner.alt} />
                            </div>
                        ))}
                    </Slider>
                )}
            </section>

            <section className="home-section intro-section">
                <p className="eyebrow">Educação gratuita, voo coletivo</p>
                <h1>Democratizando a educação</h1>
                <p className="lead">O Olympic Birds amplia o acesso a oportunidades acadêmicas e prepara estudantes para olimpíadas científicas e vestibulares.</p>
                <Link className="button button-primary" to="/quemsomos">Conheça o projeto</Link>
            </section>

            <section className="home-section" aria-labelledby="content-title">
                <div className="section-heading"><p className="eyebrow">Para cada etapa da jornada</p><h2 id="content-title">Nossos conteúdos</h2></div>
                <div className="content-grid">
                    {content.map(item => <article className="content-card" key={item.title}>
                        <img src={item.image} alt="" />
                        <h3>{item.title}</h3><p>{item.text}</p>
                        <Link to={item.link}>{item.action} <span aria-hidden="true">→</span></Link>
                    </article>)}
                </div>
            </section>

            <section className="home-section social-section" aria-labelledby="publications-title">
                <div className="section-heading"><p className="eyebrow">Acompanhe de perto</p><h2 id="publications-title">Últimas publicações</h2></div>
                <InstagramWidget />
            </section>

            <section className="home-section video-section" aria-label="Aulas no YouTube">
                <div><p className="eyebrow">Aprenda com a gente</p><h2>Aulas para levar seu estudo mais longe</h2><p>Conteúdos claros e aprofundados para você se preparar com confiança.</p><a className="button button-outline" href="https://www.youtube.com/@OlympicBirds" target="_blank" rel="noreferrer">Conhecer o canal</a></div>
                <div className="video-responsive"><iframe src="https://www.youtube.com/embed/K_UWYOsdl6o" title="Aula Olympic Birds no YouTube" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></div>
            </section>

            <section className="home-section community-section"><p className="eyebrow">Nossa comunidade olímpica</p><h2>Vamos voar juntos?</h2><p>Troque experiências, tire dúvidas e encontre pessoas que também querem chegar mais longe.</p><a className="button button-primary" href="https://chat.whatsapp.com/LNxdKHySQPD1H3KkzmjD5o" target="_blank" rel="noreferrer">Entrar na comunidade</a></section>
        </main>
    );
};

export default Home;
